export const ClientMessage = () => {
  return (
    <div className="m-2 mt-2 flex w-full max-w-xs space-x-3">
      <div>
        <div className="rounded-r-lg rounded-bl-lg bg-gray-300 p-2">
          <p className="text-xs">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
        </div>
        <span className="text-[10px] leading-none text-gray-500">
          2 min ago
        </span>
      </div>
    </div>
  );
};
